// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";
import {mantineCssStyleRecordSchema} from "./primitives.zod";

export const mantineMenuDropdownPropsSchema = z.strictObject({
	style: mantineCssStyleRecordSchema.optional(),
});
